import { useEffect, useState } from 'react';
import { getNetwork, isAccessDeniedError } from '../utils/getNetwork';

// Проверяет доступ к модулю одним лёгким probe-запросом.
// Бек на отсутствие прав отвечает 403 { code: "ACCESS_DENIED" } на любой
// эндпоинт модуля, поэтому одной проверки достаточно для всей страницы.
export const usePageAccess = (probeUrl) => {
  const [checking, setChecking] = useState(true);
  const [isAccessDenied, setIsAccessDenied] = useState(false);

  useEffect(() => {
    let cancelled = false;

    getNetwork()
      .get(probeUrl)
      .catch((err) => {
        if (!cancelled && isAccessDeniedError(err)) {
          setIsAccessDenied(true);
        }
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [probeUrl]);

  return { checking, isAccessDenied };
};
